

import { fetchLang } from '@util/http'; 
const headers = {
	"content-type": "application/json"
}

export function doLogin(params) {
	return fetchLang('/api/auth/doLogin', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

export function sendCode(params) {
	return fetchLang('/api/auth/sendSmsCodeArtMuseumV2', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

export function forgetPwd(params) {
	return fetchLang('/api/auth/forgetPwd', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

export function queryWxCode(params) {
	return fetchLang(`/api/wx/qr`, {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
}

//获取 跳转地址加签后的 url
export function queryWxCallbackUrl(param) {
	return fetchLang(`/api/wx/redirectShortCode`, {
		method: "POST",
		headers,
		body: JSON.stringify(param)
	}).then(res => res.json())
}

export function doLogout(params) {
	return fetchLang('/api/account/doLogout?token=' + params.token + '&platform=MATERIAL', {
		method: "POST",
		headers,
		body: JSON.stringify({})
	}).then(res => res.json())
}

export function getLoginQrCode(params) {
	return fetchLang('/api/auth/getLoginQrCode?width=' + params.width + '&height=' + params.height, {
		method: "GET"
	}).then(res => res.json())
}

export function queryQrCodeStatus(params) {
	return fetchLang('/api/auth/queryQrCodeLoginStatus?qrCodeKey=' + params.qrCodeKey, {
		method: "GET"
	}).then(res => res.json())
}

export function queryAliPayCode() {
	return fetchLang('/api/ali/qr', {
		method: "GET"
	}).then(res => res.json())
}

export function downloadImag(params) {
	return fetchLang('/api/zip_images', {
		headers,
		method: "POST",
		body: JSON.stringify(params)
	}).then(res => res.json())
}

export function updatePassword(params) {
	return fetchLang('/api/user/updatePassword', {
		headers,
		method: "POST",
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// 临时用户
export function userTempToken() {
	return fetchLang('/api/userTempToken', {
		method: "GET"
	}).then(res => res.json())
}

// 判断是否为临时用户
export function verifyUserTempToken() { // "isValid":0失效, 1有效, -1非临时token
	return fetchLang('/api/verifyUserTempToken', {
		method: "GET"
	}).then(res => res.json())
}


export function verifyUserTempTokenNoLang() { // "isValid":0失效, 1有效, -1非临时token

	return fetch('/api/verifyUserTempToken', {
		method: "GET"
	}).then(res => res.json())
}

// 判断真实token是否有效 /api/verifyUserToken
export function verifyUserToken() {
	return fetchLang('/api/verifyUserToken', {
		method: "GET"
	}).then(res => res.json())
}

export function verifyUserTokenNoLang() {

	return fetch('/api/verifyUserToken', {
		method: "GET"
	}).then(res => res.json())
}

//WEB端关联登录：一端登录，则让另一端也登录成功
export function doRelativeLogin(params) {
	return fetchLang('/api/auth/doRelativeLogin?token=' + params.token, {
		headers,
		method: "POST",
		body: JSON.stringify(params)
	}).then(res => res.json())
}

// captcha 验证
export function verifyIntelligentCaptcha(params, acceptLanguage) {
	return fetchLang('/api/aliCaptcha/verifyIntelligentCaptcha', {
		headers,
		method: "POST",
		body: JSON.stringify(params)
	}, acceptLanguage).then(res => res.json())
}
